// extracted by mini-css-extract-plugin
export default {"darkTheme":"Theme-darkTheme-2f8o0"};